module.exports = __webpack_public_path__ + "static/img/iv_none.f1ba9f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/iv_none.png
// module id = 73Fe
// module chunks = 1